'use strict';

import { hostFactory as hostInstance } from "@api/factory";

import { LoggerBus } from '@app/utils/logger-bus';
const loggerFormat = '[api::announcements]';

const announcements = () => {
  LoggerBus.$log.debug(loggerFormat);
  return hostInstance.get(`/api/announcements/announcements`);
}

export default {
  announcements
};